module.exports = __webpack_public_path__ + "static/media/8_l_stul_2.45_80.37.1a5a6eae.png";